import React from "react";
import { getPricingSourceSummary } from "../../utils/pricingUi";

const TONE_CLASS = {
  default: "border-slate-300 bg-slate-100 text-slate-700",
  project: "border-sky-300 bg-sky-100 text-sky-800",
  client: "border-emerald-300 bg-emerald-100 text-emerald-800",
  profile: "border-amber-300 bg-amber-100 text-amber-800",
  legacy: "border-orange-300 bg-orange-100 text-orange-800",
  manual: "border-rose-300 bg-rose-100 text-rose-800",
};

export default function PricingSourceBadge({ snapshot, className = "" }) {
  const meta = getPricingSourceSummary(snapshot);

  return (
    <span
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium ${TONE_CLASS[meta.tone] || TONE_CLASS.default} ${className}`.trim()}
      title={meta.scopeType || meta.sourceType || meta.label}
    >
      {meta.label}
    </span>
  );
}
